/* global marketsCords */
import getNearestPlaces from "../components/geolocation";
import { setInSelectByText } from "../utils/other";
//GEOLOCATION
function triggerGetNearestPlaces() {
  let shouldSkip = false;

  getNearestPlaces()
    .then((places) => {
      //Check all nearby location
      places.locations.forEach((location) => {
        if (shouldSkip) return;
        const option = document.querySelector(
          `[data-location_name="${location.city}"]`
        );

        if (option) {
          setNearLocationInForm(location);
          shouldSkip = true;
        }
      });

      //if not find in select check only in not custom locations
      places["locations_without_custom"].forEach((location) => {
        if (shouldSkip) return;
        const option = document.querySelector(
          `[data-location_name="${location.city}"]`
        );

        if (option) {
          setNearLocationInForm(location);
          shouldSkip = true;
        }
      });

      searchAndDropdownMarketsGeo(places.markets[0]);
    })
    .catch(() => {});
}

triggerGetNearestPlaces();

$(window).on("load", function () {
  triggerGetNearestPlaces();
});

function setNearLocationInForm(nearLocation) {
  let locationsSelect = document.querySelectorAll(".f_location_id");
  locationsSelect.length
    ? setInSelectByText(locationsSelect, nearLocation, "city")
    : null;
}

//TODO: after AB test move it to components
function searchAndDropdownMarketsGeo(market) {
  let { city, id } = market;

  let defaultUrl = marketsCords.reduce((acc, market) => {
    if (market.id === id) {
      acc = market.link;
    }
    return acc;
  }, "");

  if ($("#searchFormGeolocated").length > 0 && defaultUrl) {
    $("#s").attr("data-default-url", defaultUrl);
    $("#search-form-label-default").fadeOut(300, () => {
      $("#search-form-label-city").text(`${city}`);
      $("#search-form-label-alternate").fadeIn(300);
    });

    // tracking stuff
    $("#searchFormGeolocated .js-search-form-button").attr(
      "id",
      "searched_" + city
    );
    $("#searchFormGeolocated .js-search-form-button").attr(
      "data-url",
      defaultUrl
    );
  }
}
